import script from "./AccesosList.vue?vue&type=script&setup=true&lang=js"
export * from "./AccesosList.vue?vue&type=script&setup=true&lang=js"

import "./AccesosList.vue?vue&type=style&index=0&id=50b9ab6c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50b9ab6c"]])

export default __exports__